import { useEffect } from 'react';

function getOrCreateMetaTag(name) {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  return tag;
}

export function usePageMetadata({ title, description }, prevailOnUnmount = false) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    const titleTag = getOrCreateMetaTag('title');
    const previousMetaTitle = titleTag.getAttribute('content');
    titleTag.setAttribute('content', title);

    const descTag = getOrCreateMetaTag('description');
    const previousDescription = descTag.getAttribute('content');
    descTag.setAttribute('content', description);

    return () => {
      if (!prevailOnUnmount) {
        document.title = previousTitle;

        if (previousMetaTitle != null) {
          titleTag.setAttribute('content', previousMetaTitle);
        } else {
          document.head.removeChild(titleTag);
        }

        if (previousDescription != null) {
          descTag.setAttribute('content', previousDescription);
        } else {
          document.head.removeChild(descTag);
        }
      }
    };
  }, [title, description, prevailOnUnmount]);
}
